export { NAVS_SERV, MAP_ALL_ATTRS_SERV }
const MAP_ATTRS_SERV = {
	id:'ATTRS_SERV',
	navLabel:'sidenav.service.label',
	navIcon:'exchange',
	instancesClass:{
		servunit:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'unitCode', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'unitName', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: false},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: false},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		servformat:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'formatCode', attrCol: '14%', searchable: true, sortable: true},
				{attrName: 'formatName', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'quantity', attrCol: '8%', searchable: false, sortable: true},
				{attrName: 'nombre', attrCol: '8%', searchable: false, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		servcategory:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'categoryCode', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'categoryName', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		servtypecat:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'typeCatCode', attrCol: '15%', searchable: true, sortable: true},
				{attrName: 'typeCatName', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'servCategoryLib', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		servservice:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'serviceCode', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'serviceName', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		servstatus:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'code', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'statusName', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		servtypees:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'typeESCode', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'typeESName', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		servtype:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'typeCode', attrCol: '7%', searchable: true, sortable: true},
				{attrName: 'typeName', attrCol: '23%', searchable: true, sortable: true},
				{attrName: 'servCategoryLib', attrCol: '8%', searchable: false, sortable: true},
				{attrName: 'servTypeCatLib', attrCol: '12%', searchable: false, sortable: true},
				{attrName: 'servFormatLib', attrCol: '8%', searchable: false, sortable: true},
				{attrName: 'servUnitLib', attrCol: '5%', searchable: false, sortable: true},
				{attrName: 'dateCreated', attrCol: '13%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '13%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '15%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		servtypeserv:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'servServiceLib', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'servTypeLib', attrCol: '25%', searchable: false, sortable: true},
				{attrName: 'stock', attrCol: '10%', searchable: false, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		servtypestockes:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'servTypeLib', attrCol: '25%', searchable: false, sortable: true},
				{attrName: 'servServiceLib', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'servTypeESLib', attrCol: '10%', searchable: true, sortable: true},
				{attrName: 'quantity', attrCol: '10%', searchable: false, sortable: true},
				{attrName: 'cost', attrCol: '12%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '15%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		servtypeservstore:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'servTypeServLib', attrCol: '40%', searchable: false, sortable: true},
				{attrName: 'prsStoreLib', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'stock', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '15%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
	}
}
const NAVS_SERV = [MAP_ATTRS_SERV]

const MAP_ALL_ATTRS_SERV = {};
for (let key in MAP_ATTRS_SERV.instancesClass) {
	MAP_ALL_ATTRS_SERV[key]= MAP_ATTRS_SERV.instancesClass[key]
}